"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeChurnZero = initializeChurnZero;
const core_1 = require("../core/index.js");
function isChurnZeroAnalyticsEnabled() {
    const { churn_zero_app_key } = window.sonar;
    // eslint-disable-next-line camelcase
    return Boolean(churn_zero_app_key) && (0, core_1.isAnalyticsEnabled)();
}
function initializeChurnZero(data) {
    if (isChurnZeroAnalyticsEnabled()) {
        const cz = window.ChurnZero || [];
        cz.push(['setAppKey', window.sonar.churn_zero_app_key]);
        cz.push(['setContact', data.externalAccountId, data.externalContactId]);
        cz.push(['trackEvent', 'Login']);
    }
}
//# sourceMappingURL=lib.js.map